import React, { useEffect } from 'react';

const Alert = ({ type = 'info', message, onDismiss }) => {
    useEffect(() => {
        if (!onDismiss || !message) return;

        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onDismiss();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [onDismiss, message]);

    if (!message) return null;

    const styles = {
        error: 'bg-red-50 border-red-200 text-red-700',
        success: 'bg-green-50 border-green-200 text-green-700',
        warning: 'bg-yellow-50 border-yellow-200 text-yellow-700',
        info: 'bg-blue-50 border-blue-200 text-blue-700',
    };

    return (
        <div className={`${styles[type]} border px-4 py-3 rounded-lg mb-4 flex items-center justify-between`}>
            <span>{message}</span>
            {onDismiss && (
                <button
                    onClick={onDismiss}
                    className="ml-4 text-current opacity-70 hover:opacity-100 focus:outline-none"
                    aria-label="Dismiss"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            )}
        </div>
    );
};

export default Alert;
